import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import { useParams } from 'react-router-dom';

import { useFreecodeContextRun, useFreecodeContextData } from 'hooks/useContext';
import FreecodeCourseExpandingItem from './FreecodeCourseExpandingItem';
import { RoundIconButtonLink } from 'components/Button/IconButton';
import { CourseTabContent, SyllabusContainer, CourseNameContainer, CourseName, Icon, ModuleContainer } from './styles';

export default function FreecodeCourse() {
  const { exerciseId } = useParams();

  const { course, languageData } = useFreecodeContextData();
  const { language } = useFreecodeContextRun();
  const [courseStructure, setCourseStructure] = useState({});

  useEffect(() => {
    if (!course?._id) return;
    let courseCopy = JSON.parse(JSON.stringify(course));
    let index = _.findIndex(courseCopy.syllabus, function (lesson) {
      if (lesson.exercise && String(lesson.exercise.id) === String(exerciseId)) return true;
      else {
        let exercises = _.pluck(lesson.modules, 'exercise');
        let exercisesId = _.pluck(exercises, 'id');
        let found = _.find(exercisesId, function (exercise) {
          return String(exercise) === String(exerciseId);
        });
        if (found) return true;
      }
    });
    courseCopy.active = true;
    courseCopy.syllabus[index].active = true;
    setCourseStructure(courseCopy);
  }, [course, exerciseId]);

  const setLessonActive = function (index, isCourse) {
    let courseCopy = JSON.parse(JSON.stringify(courseStructure));
    if (isCourse) courseCopy.active = !courseCopy.active;
    else courseCopy.syllabus[index].active = !courseCopy.syllabus[index].active;
    setCourseStructure(courseCopy);
  };

  const checkIsExerciseCompletedInLanguage = (values, testImpl, language, exerciseId) =>
    _.every(_.pluck(values, 'isCompleted'), (value) => value === true);

  const renderLessons = (lesson, index) => (
    <FreecodeCourseExpandingItem
      title={lesson.name}
      openDyDefault={lesson.active}
      toggled={() => setLessonActive(index)}
      key={index}
    >
      <SyllabusContainer>
        {lesson.modules.map((module) => (
          <ModuleContainer
            active={module.exercise.id === exerciseId}
            href={`/exercise/${module.exercise.id}?courseId=${course._id}`}
            key={module.exercise.id}
          >
            <Icon
              icon={
                checkIsExerciseCompletedInLanguage(
                  module.exercise.languagesCompleted[language],
                  module.exercise.testImpl,
                  language,
                  module.exercise.id
                )
                  ? 'fa-regular fa-circle-check'
                  : 'fa-regular fa-circle'
              }
            ></Icon>
            {module.name}
          </ModuleContainer>
        ))}
      </SyllabusContainer>
    </FreecodeCourseExpandingItem>
  );

  return (
    <CourseTabContent>
      <CourseNameContainer>
        <CourseName>{`${courseStructure.name} (${languageData[language].SimpleName}) `}</CourseName>
        <RoundIconButtonLink icon="fa fa-external-link" link={`/courses/${course._id}`} />
      </CourseNameContainer>
      {courseStructure.active && (
        <div>{courseStructure.syllabus.map((syllabus, index) => renderLessons(syllabus, index))}</div>
      )}
    </CourseTabContent>
  );
}
